export const HeaderFooterProvider = _ref => {
  let {
    locale,
    brand = 'wix',
    isAnonymous
  } = _ref;
  if (!isAnonymous) {
    return;
  }
  const scriptId = 'header-footer-provider-script';
  const existingScript = document.getElementById(scriptId);
  if (!existingScript) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://static.parastorage.com/unpkg-semver/header-footer-provider/app.bundle.min.js';
    script.onload = () => {
      window['header-footer-provider'].initHeaderFooter({
        stickyBehaviour: 'mobile-only',
        language: locale,
        brand
      });
    };
    document.body.appendChild(script);
  }
};
//# sourceMappingURL=HeaderFooterProvider.js.map